import React from 'react'
import './DetailsMapComp.css';
import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';


const DetailsMapComp = () => {

    const containerStyle = {
        width: '100%',
        height: '100%'
      };
      
      const center = {
        lat: -3.745,
        lng: -38.523
      };
    
      const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyDx_nTwWLB8u7jpIpiXzuOkY7vk_LIq1fw"
      })
    
      const [map, setMap] = React.useState(null)
    
      const onLoad = React.useCallback(function callback(map) {
        const bounds = new window.google.maps.LatLngBounds(center);
        map.fitBounds(bounds);
        setMap(map)
      }, [])
    
    
    return (
    <div>
        <p style={{fontWeight:700,fontSize:22,textAlign:'left',marginLeft:'5%',marginTop:30}}>Location of Asset</p>
                    <div className='DetailsmapDiv'>
        {
          isLoaded &&
        <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={10}
        onLoad={onLoad}
        // onUnmount={onUnmount}
      >
      </GoogleMap>
        }
            </div>

    </div>
  )
}

export default DetailsMapComp